<template lang="html">  
<div class="container">
<section class="josecopy d-flex " >
  
  <card class="mb-4 col-lg-3 col-md-5 col-sm-5 col-xs-12 card" v-for="inst in documentos " v-bind:articulo="inst" v-bind:key="inst.nombre"/>

</section>
</div>
  
</template>

<script lang="js">
import card from './card.vue'
import {db} from "./db"



  export default  {
    name: 'productos',
    props: [],
  
    data () {
      return {
 
    documentos:[],
   
      }
    },


    firestore:{
      documentos: db.collection("instrumentos"),
    
    },

    components:{
        card
    },
}

</script>

<style>

.josecopy{
  margin-top:-50px;
padding-top:60px;
padding-bottom: 75px;

}

 section{

flex-wrap: wrap;
justify-content:center;
width: 100%;
 }

 .container{
  margin-top:45px;
 background-color: rgba(228, 228, 228, 0.76);

max-width: 100% !important;
}

 .card{background-color: white;
  display: flex;
  justify-content: center;
 }

</style>
